"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgCameraOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M29.55 10.61a23.32 23.32 0 00-5.74-2.48L22.78 4H9.22l-1 4.13a23.32 23.32 0 00-5.74 2.48l-.45.3V26H30V10.91zM28 24H4V12a23.5 23.5 0 015.29-2.1l.56-.15.93-3.75h10.44l.94 3.75.56.15A23.57 23.57 0 0128 12z" }),
        React.createElement("path", { d: "M16 10a6 6 0 106 6 6 6 0 00-6-6zm0 10a4 4 0 114-4 4 4 0 01-4 4z" })));
}
exports.default = SvgCameraOutline;
//# sourceMappingURL=CameraOutline.js.map